import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import AddTickets from '../../ticket-picker/components/AddTickets';
import ProductProps from './ProductComponent';
import FormattedCurrency from '@s/FormattedCurrency';
import ImageGalleryWrapper from '@s/ImageGalleryWrapper'
import DetailsToggle from '@s/DetailsToggle'
import ProductConfigurationWrapper from '../containers/ProductConfigurationWrapper'
import Translation from "../../../../shared/Translation";
import classNames from 'classnames';
import { getXssFilter } from 'checkout/helpers/helpers';

class Product extends Component<ProductProps> {
    constructor(props) {
        super(props);
        this.state = {showDescription: false}
    }

    displayGallery = () => {
        let imageGallery = <div></div>;
        if (this.props.product.images && this.props.product.images.length >= 1) {
            imageGallery = <Fragment>
                {this.state.showDescription === true &&
                 <div className="image__gallery">
                    <ImageGalleryWrapper
                        images={this.props.product.images}
                        altTexts={this.props.product.images_alt_texts}
                        name={this.props.product.name}
                    />
                </div>
                }
            </Fragment>;
        }

        return imageGallery;
    };

    toggleDescription = () => {
        this.setState({showDescription: !this.state.showDescription});
    };

    getProductImageUrl = () => {
        return "url(" + this.props.product.images[0] + ")";
    };

    displayProductConfiguration = () => {
        if (!this.props.product.single_configuration && this.props.productQuantity > 0) {
            let productConfigLines = [];
            for (let i = 0; i < this.props.productQuantity; i++) {
                productConfigLines.push(<div className="product__configuration__option" key={'config_line_' + i}>
                    <ProductConfigurationWrapper
                        key={i}
                        product={this.props.product}
                        configKey={i}
                        productQuantity={this.props.productQuantity}
                        reducerKey={this.props.reducerKey}
                    />
                </div>);
            }

            return (<div className="product__configurations__wrapper ticket__item">
                    <h4 className="product__configurations__title"><Translation>{"checkout__product"}</Translation></h4>
                    {productConfigLines}
                </div>
            )
        }
    };

    renderAddTicketsControl = (props = {}) => {
        return (
            <AddTickets
                {...props}
                onIncrement={this.props.onProductIncrement}
                onDecrement={this.props.onProductDecrement}
                quantity={this.props.productQuantity}
                quantities={this.props.productQuantities}
                onQuantityInput={this.props.onProductsQuantityInput}
                initialQuantities={this.props.initialQuantities}
            />
        );
    }

    renderDescription = () => {
        if (!this.state.showDescription) {
            return null;
        }
        return (
            <div
              id={`description_product_${this.props.product.product_id}`}
              className="ticket-description__more ticket__item"
            >
                {this.displayGallery()}
                <div className="ticket__description">
                    <div
                      className="ticket-description__content ticket-description__content-desc"
                      dangerouslySetInnerHTML={{
                        __html: getXssFilter().process(this.props.product.description)
                      }}
                    />
                </div>
            </div>
        );
    }

    render() {
        const { price, service_fee } = this.props.product;
        const totalPrice = price.amount + (service_fee?.price || 0);
        return <Fragment>
            <div className="ticket">
                <div className={`ticket__information ${this.props.product.images ? 'product--has-thumbnail': ''}`}>
                    <div className="product__name-container">
                        {(this.props.product.images && this.props.product.images.length >= 1) &&
                            <div className="product__image">
                                <img
                                    src={this.props.product.images[0]}
                                    alt={(this.props.product.images_alt_texts && this.props.product.images_alt_texts[0] && this.props.product.images_alt_texts[0].trim()) ? this.props.product.images_alt_texts[0] : `'${this.props.product.name}' Thumbnail`}
                                />
                            </div>
                        }
                        <div>
                            <div id={`name_product_${this.props.product.product_id}`} className="ticket__name" role='heading' aria-level='3'>{this.props.product.name}</div>
                            <div className={classNames("ticket__pricing-group", {
                              "hide-on-medium-screen": !this.props.showPriceInInfo
                            })}>
                              <div className="ticket__price--total">
                                    <FormattedCurrency>{ totalPrice }</FormattedCurrency>
                                  </div>
                            </div>
                              {service_fee && service_fee.price > 0 ? (
                                <>
                                  <div className="ticket__price">
                                    <FormattedCurrency>{ price.amount }</FormattedCurrency> + <FormattedCurrency>{ service_fee.price }</FormattedCurrency> 
                                    &nbsp;<Translation>{this.props.feeVerbiage ? 'checkout__fees_label' : 'checkout__service_fee_label'}</Translation>
                                  </div>
                                </>
                              ) : (
                                <div className="ticket__price">
                                  <FormattedCurrency>{ price.amount }</FormattedCurrency>
                                </div>
                              )}

                            {(this.props.product.description || (this.props.product.images && this.props.product.images.length >= 1)) && (
                                <DetailsToggle
                                  onClick={this.toggleDescription}
                                  aria-expanded={this.state.showDescription}
                                  aria-controls={`description_product_${this.props.product.product_id}`}
                                  aria-describedby={`name_product_${this.props.product.product_id}`}
                                />
                            )}
                        </div>
                    </div>
                </div>
                {this.props.showPriceInInfo && <div className="ticket__price--placeholder" />}
                {!this.props.showPriceInInfo && (
                  <div className="ticket__pricing-group hide-on-small-screen">
                    <div className="ticket__price--total"><FormattedCurrency>{ totalPrice }</FormattedCurrency></div>
                  </div>
                )}
                <div className="ticket__action">
                    {this.renderAddTicketsControl()}
                </div>
            </div>
            {this.renderDescription()}
            {this.displayProductConfiguration()}
        </Fragment>
    }
}

Product.propTypes = {
    product: PropTypes.object.isRequired,
    slug: PropTypes.string,
    productQuantity: PropTypes.number,
    productQuantities: PropTypes.arrayOf(PropTypes.number).isRequired,
    initialQuantities: PropTypes.arrayOf(PropTypes.number),
    onProductsQuantityInput: PropTypes.func.isRequired,
    onProductIncrement: PropTypes.func.isRequired,
    onProductDecrement: PropTypes.func.isRequired,
    createProductConfigurationLine : PropTypes.bool,
    showPriceInInfo: PropTypes.bool,
    feeVerbiage: PropTypes.bool
};

export default Product;
